<template lang="pug">
span(:class='{ __error: vError }')
  label.__form-label(v-if='label', :for='name')
    | {{ label }}
    span.red(v-if="required" ) *
  span.__form-input__container(v-if='isInput')
    span.__form-input__append(v-if='appendPhone') +7
    input.__form-input(
      v-if='!mask',
      :key='tag',
      :type='type',
      :class='classes',
      :disabled='disabled',
      :placeholder='placeholder',
      :readonly='readonly',
      :value='value',
      @input='input',
      @blur='blur',
      @focus='$emit("focus")'
      :name='name'
    )
    MaskedInput.__form-input(
      v-else,
      :key='tag',
      :type='type',
      :class='classes',
      :disabled='disabled',
      :placeholder='placeholder',
      :readonly='readonly',
      :mask='mask',
      :value='value',
      @input='input',
      @blur='blur',
      :name='name'
    )
  .text(v-if='vError') {{ errorText }}
  .add_text(v-if="addText" ) {{ addText }}
  .link(v-if='$slots.link')
    slot(name='link')
  slot
</template>

<script>
import MaskedInput from 'vue-text-mask';

export default {
  components: { MaskedInput },

  props: {
    name: {
      type: String,
      default: '',
    },

    errorText: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: '',
    },

    value: {
      type: [String, Number],
      default: '',
    },

    error: {
      type: [String, Number, Boolean],
      default: '',
    },

    mask: {
      type: [String, Array, Boolean],
      default: false,
    },

    isInput: {
      type: Boolean,
      default: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    showMask: {
      type: Boolean,
      default: false,
    },

    v: {
      type: [Object, Function, Boolean],
      default: null,
    },

    large: {
      type: Boolean,
      default: true,
    },

    appendPhone: {
      type: Boolean,
      default: false,
    },

    required: {
      type: Boolean,
      default: false,
    },
    addText: {
      type: String,
      default: '',
    }
  },

  computed: {
    vError() {
      return this.error || (this.v && this.v.$error);
    },

    tag() {
      return this.mask ? 'masked-input' : 'input';
    },

    classes() {
      return {
        '__form-input_small': !this.large,
        '__form-input_large': this.large,
        '__form-input_append': this.appendPhone,
      };
    },
  },

  methods: {
    input($event) {
      const value = $event.target ? $event.target.value : $event;
      this.touch();
      this.$emit('input', value);
    },

    blur($event) {
      this.touch();
      this.$emit('blur', $event);
    },

    touch() {
      if (this.v && !this.mask) {
        this.v.$touch();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.red
  color red
.add_text
  font-size: 0.75em;
  line-height: 1.25em;
.__form-label
  color #252525
  display block
  font-size 10px
  line-height 1.4
  text-transform uppercase
  font-family 'Open Sans', sans-serif
  margin-bottom 8px
  text-align left

.__form-input
  padding 0 10px
  height 36px
  width 100%
  font-family 'Open Sans', sans-serif
  display inline-block
  vertical-align middle
  font-size 14px
  color: rgba(0, 0, 0, 0.85)
  line-height 34px
  text-overflow ellipsis
  background-color #fff
  border-radius 2px
  border 1px solid #cfd4d8
  box-shadow inset 2px 2px 8px rgba(0,0,0,.1)
  transition all .3s ease-in-out

  &_small
    box-sizing border-box
    border 1px solid #d2d2d2
    border-radius .2em
    outline 0
    line-height 1.5em
    text-align left
    position relative
    font-weight 700
    font-size 10px
    font-family 'Open Sans',sans-serif
    text-transform uppercase
    line-height 24px
    height 26px

    &::-webkit-input-placeholder
      font-size 10px

    &:focus
      border-color #cfd4d8 !important

  &::-webkit-input-placeholder
    font-family 'Open Sans',sans-serif
    text-transform uppercase
    font-size 11px
    color #9e9e9e

  &_large
    line-height: 34px
    height: 36px

    &::-webkit-input-placeholder
      font-size 11px

    &:focus
      border-color #09f !important

  &_append
    border-radius 0 2px 2px 0

  &__append
    font-family 'Open Sans', sans-serif
    font-size 14px
    width 36px
    padding 12px 11px 10px
    background-color #cfd4d8
    border-radius 2px 0 0 2px

  &__container
    display flex
    align-items center

  &:focus,
  &:active
    outline none
    border-color #09f !important

  &:hover
    border 1px solid #a5aeb5
    box-shadow inset 2px 2px 8px rgba(0,0,0,.15)

.__error
  .__form-input
    color red
    border-color red

    &::-webkit-input-placeholder
      color red
  .text
    color red
    font-size .75em
    line-height 1.25em

  .link >>> a
    font-size .75em
</style>



// WEBPACK FOOTER //
// Input.vue?1fedbe84